import { useEffect, useMemo, useState } from "react";
import Client from "../../../../services";
import CourseAssetDetailsView from "./CourseAssetDetails";
import CourseAsset from "../CourseAsset";

const _BASE_CLASS = 'online-course-assets';

async function fetchAssetById(id){
    const {success, data, message} = await Client.api.get(`/admin/online-course/month/week/day/asset/${id}`);
    return data;
}

function _CourseAssetsView({
    topic,
    assets,
    onDeleteAsset,
    onAddAsset
}){
    // const [assets, setAssets] = useState([]);

    // useEffect(()=>{
    //     Promise.all(topic.assets.map(id => fetchAssetById(id)))
    //     .then((data) => setAssets(data.filter(v => !!v)))
    // }, [topic.assets]);

    const {
        classworks,
        homeworks
    } = useMemo(() => {
        const classworks = {
            items: []
        }
        const homeworks = {
            items: []
        }
        for(let asset of assets){
            switch(asset.playType){
                case 'CLASSWORK': {
                    classworks.items.push(asset);
                    break;
                }
                case 'HOMEWORK': {
                    homeworks.items.push(asset);
                    break;
                }
            }
        }
        return {
            classworks,
            homeworks
        }
    }, [assets])
    

    console.log({topic, assets});
    console.log({homeworks, classworks});
    return <div
        className={`${_BASE_CLASS}`}
    >
        <div
            className={`${_BASE_CLASS}__header`}
        >
            <span>
                Topic: {topic.title}
            </span>
            <button onClick={onAddAsset}>Add New Asset</button>
        </div>

        <div
            className={`${_BASE_CLASS}__container`}
        >
            {
                assets.map((asset, i) => <CourseAssetDetailsView key={`${asset._id}`} index={i} assetId={asset._id} onDeleteAsset={onDeleteAsset} />)
            }
        </div>

    </div>
}

export const CourseAssetsView = _CourseAssetsView;
